/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerheadline2Inputs */

const en_checkinflyerheadline2 = /** @type {(inputs: Checkinflyerheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who else is here?`)
};

const de_checkinflyerheadline2 = /** @type {(inputs: Checkinflyerheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer ist noch hier?`)
};

/**
* | output |
* | --- |
* | "Who else is here?" |
*
* @param {Checkinflyerheadline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerheadline2 = /** @type {((inputs?: Checkinflyerheadline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerheadline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerheadline2(inputs)
	return de_checkinflyerheadline2(inputs)
});
export { checkinflyerheadline2 as "checkinFlyerHeadline" }